import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  useTheme,
  Paper,
  Box,
  Tooltip,
  Typography,
  useMediaQuery,
  Link,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import { getRaPathWithChallangeFilter, shortenStringMiddle2 } from 'src/common/utils'

import { ETranslationNs, IChallengesLiderboardItem, IChallengeWithStats } from 'src/types'
import { useStyles } from './../../styles'

import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  challangeName: string
  leaderboard: IChallengesLiderboardItem[]
  userPlacement: IChallengeWithStats['userPlacement']
}

export const LeaderboardTable = ({ leaderboard, userPlacement, challangeName }: IProps) => {
  const [t] = useTranslation([ETranslationNs.Common])
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('tablet'))
  const classes = useStyles()

  // const handleCopy = useCopy(item.default_wallet)

  const extra = userPlacement && userPlacement.position > 10 ? userPlacement : null

  return (
    <TableContainer component={Paper} sx={{ mt: 2, width: 'fit-content' }}>
      <Table size="small" aria-label="Leaderboard">
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>
              <HelperWrapper t="consumer-challenges-username-column" />
            </TableCell>
            <TableCell sx={{ px: '6px' }} align="right">
              <HelperWrapper t="consumer-challenges-points-column" />
            </TableCell>
            <TableCell align="right">
              <HelperWrapper t="consumer-challenges-trai-column" />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {leaderboard.map((row, idx) => {
            const pos = idx + 1
            const isCurrent = userPlacement?.position === pos
            return (
              <TableRow
                key={row.name ?? pos}
                sx={isCurrent ? { backgroundColor: theme.palette.action.hover } : {}}
              >
                <TableCell>{pos}</TableCell>
                <TableCell>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '3px',
                      justifyContent: 'start',
                    }}
                  >
                    <Tooltip title={row.wallet_address}>
                      {row.name ? (
                        <Typography fontSize={'14px'}>{row.name}</Typography>
                      ) : (
                        <Typography sx={{ fontSize: '14px' }}>
                          {shortenStringMiddle2(row.wallet_address, isMobile ? 11 : 20, '...')}
                        </Typography>
                      )}
                    </Tooltip>
                    {/* 
                    <Box sx={{ display: 'flex', gap: isMobile ? '0px' : '3px' }}>
                      <IconButton
                        disabled={!row.wallet_address}
                        size="small"
                        component={Link}
                        href={
                          row.wallet_address ? getPolygonscanAddressUrl(row.wallet_address) : '#'
                        }
                        target="_blank"
                      >
                        <LinkIcon className={isMobile ? classes.copyIconSmall : classes.copyIcon} />
                      </IconButton>

                      <IconButton size="small" disabled={!row.wallet_address} onClick={() => {}}>
                        <ContentCopyIcon
                          className={isMobile ? classes.copyIconSmall : classes.copyIcon}
                        />
                      </IconButton>
                    </Box> */}
                  </Box>
                </TableCell>
                <TableCell sx={{ px: '6px' }} align="right">
                  {isCurrent ? (
                    <Link href={getRaPathWithChallangeFilter(challangeName)}>{row.points}</Link>
                  ) : (
                    <Typography fontSize={'14px'}>{row.points}</Typography>
                  )}
                </TableCell>
                <TableCell align="right">{row.trai}</TableCell>
              </TableRow>
            )
          })}

          {extra && extra.position > 11 && (
            <TableRow>
              <TableCell colSpan={4} align="center">
                …
              </TableCell>
            </TableRow>
          )}

          {extra && (
            <TableRow sx={{ backgroundColor: theme.palette.action.hover }}>
              <TableCell>{extra.position}</TableCell>
              <TableCell>
                {
                  <Tooltip title={extra.wallet_address}>
                    <Typography fontSize={'14px'}>{'You'}</Typography>
                  </Tooltip>
                }
              </TableCell>
              <TableCell sx={{ px: '6px' }} align="right">
                <Link href={getRaPathWithChallangeFilter(challangeName)}>{extra.points}</Link>
              </TableCell>
              <TableCell align="right">{extra.trai}</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
